import React from "react";
import styles from "./CardHeaderAvatarPreloader.module.scss";

const CardHeaderAvatarPreloader = () => {
  return <div className={styles.preloader} />;
};

export default CardHeaderAvatarPreloader;
